import { Subscription } from 'rxjs';
import { ValueListsService } from './value-lists.service';

export interface ValueList {
  name: string,
  property: string
}

export function loadValueLists(
  valueListsService: ValueListsService,
  valueLists: { name: string; property: string }[],
  target: any,
  subscriptions: Subscription
): void {
  valueLists.forEach(list => {
    subscriptions.add(
      valueListsService.getValueListItems(list.name)
      .subscribe(items => target[list.property] = items)
    );
  });
}
